import styled from "@emotion/styled";
import { Variables } from "@repo/skapa";

interface TwoColumnsContainerProps {
  split?: "equal" | "70-30";
}

const TwoColumnsContainer = styled.div<TwoColumnsContainerProps>`
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: ${Variables.breakpointL}) {
    grid-template-columns: ${({ split }) =>
      split === "70-30" ? "70% 29%" : "1fr 1fr"};
  }
`;

export const TwoColumnSectionContainer = styled(TwoColumnsContainer)`
  gap: ${Variables.space75};

  @media (min-width: ${Variables.breakpointM}) {
    gap: ${Variables.space150};
  }
`;

export const TwoColumnElementsContainer = styled(TwoColumnsContainer)`
  gap: ${Variables.space100};
`;
